export function getIsTouch(): boolean {
  return (
    navigator.maxTouchPoints > 0 ||
    (navigator.msMaxTouchPoints ?? 0) > 0 ||
    ('ontouchstart' in window && window.matchMedia('(pointer: coarse)').matches)
  );
}
